angular.module('dnecom')
    .filter('removeDuplicates', function() {
        return function(items) {
            var filtered = [];

            var ids = [];

            angular.forEach(items, function (item) {
                if (typeof item.id === 'undefined') {
                    if (ids.indexOf(item.value.toLowerCase()) == -1) {
                        ids.push(item.value.toLowerCase());
                        filtered.push(item);
                    }
                } else {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                        filtered.push(item);
                    }
                }
            });

            return filtered;
        };
    });
